<script setup lang="ts">
import BaseHeader from '@/components/base/BaseHeader.vue'
import BaseMenuBar from '@/components/base/BaseMenuBar.vue'
import { getProfile } from '@/service/contributor/profile'
import type { iUserProfile } from '@/stores/user/userProfile'
import { userProfileStore } from '@/stores/user/userProfile'
import { onBeforeMount } from 'vue'

const userProfile = userProfileStore()

onBeforeMount(async () => {
  try {
    const fetchResult = await getProfile()
    const profile = fetchResult?.data?.data
    if (profile != null) {
      userProfile.setUserProfile(profile as iUserProfile)
    }
  } catch (error) {
    console.error("Failed to fetch profile:", error)
  }
})
</script>
<template>
  <div
    class="flex md:flex-row flex-col overflow-auto w-full min-h-screen max-box overflow-y-hidden h-screen"
  >
    <BaseMenuBar></BaseMenuBar>
    <div class="flex flex-grow justify-center">
      <div class="w-full border-l border-slate-300">
        <BaseHeader></BaseHeader>
        <div
          class="flex flex-grow flex-shrink mb-5 justify-center border-t border-slate-300 overflow-y-scroll overflow-x-hidden h-[calc(100vh-80px)] md:h-[calc(100vh-100px)] no-scrollbar-tib"
        >
          <div class="w-full">
            <slot name="content"></slot>
            <div class="mt-10 text-center md:text-right text-gray-500 md:mr-5">
              <small>Algo Research</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
